import { ModalProps } from '@/types/shared'
import { t } from 'i18next'
import React, { useState } from 'react'
import { Button, Dialog, RadioGroup } from 'vnetwork-ui'

export interface UploadConflictModalProps extends ModalProps {
    onResolve: (result: 'replace' | 'keepAll' | 'cancel') => void
}

const UploadConflictModal: React.FC<UploadConflictModalProps> = ({
    onClose,
    open,
    onResolve,
}) => {
    const [isReplace, setIsReplace] = useState<boolean>(true)

    const description = <div>{t('conflict-description')}</div>

    const children = (
        <div className="flex flex-col gap-2">
            {description}
            <RadioGroup
                options={[
                    {
                        label: t('replace'),
                        value: 'true',
                    },
                    {
                        label: t('keep-all'),
                        value: 'false',
                    },
                ]}
                value={isReplace ? 'true' : 'false'}
                onChange={(value) => setIsReplace(value === 'true')}
            />
        </div>
    )

    const actions = (
        <div className="flex space-x-2">
            <Button
                onClick={() => {
                    onResolve('cancel')
                    onClose()
                }}
                variant="outlined"
            >
                {t('cancel')}
            </Button>
            <Button
                onClick={() => {
                    onResolve(isReplace ? 'replace' : 'keepAll')
                    onClose()
                }}
            >
                {t('upload')}
            </Button>
        </div>
    )

    return (
        <Dialog
            onClose={() => {
                onResolve('cancel')
                onClose()
            }}
            open={open}
            title={t('conflict-title')}
            children={children}
            actions={actions}
        />
    )
}

export default UploadConflictModal
